// 导入自定义 Layout 布局
import { BaseLayout, RouterView } from '@/layouts'

// 基础路由
export const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('@/views/user/Login')
  },
  {
    path: '/base-home',
    name: '首页',
    component: () => import('@/views/Home')
  },
  {
    path: '/summary-data',
    name: '汇总数据',
    component: () => import('@/views/agency/SummaryData')
  }
]

// 菜单路由
export const menuRoutes = [
  {
    component: BaseLayout,
    meta: { title: '达人撮合平台', keepAlive: false },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/Home'),
        meta: { title: '首页', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 }
      },
      {
        path: '/task',
        redirect: '/task-library',
        component: RouterView,
        meta: { title: '任务管理', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/task-library',
            name: 'TaskLibrary',
            component: () => import('@/views/task/TaskLibrary'),
            meta: { title: '任务库', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/task-pending-storage',
            name: 'TaskPendingStorage',
            component: () => import('@/views/task/PendingStorage'),
            meta: { title: '待入库', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/task-drama-library',
            name: 'TaskDramaLibrary',
            component: () => import('@/views/task/DramaLibrary'),
            meta: { title: '短剧库', keepAlive: false, icon: 'PushpinOutlined' }
          },
        ]
      },
      {
        path: '/auxiliary',
        redirect: '/auxiliary',
        component: RouterView,
        meta: { title: '配套设置', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/auxiliary-channel',
            name: 'AuxiliaryChannel',
            component: () => import('@/views/auxiliary/Channel'),
            meta: { title: '渠道设置', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/auxiliary-copyright-holder',
            name: 'AuxiliaryCopyrightHolder',
            component: () => import('@/views/auxiliary/CopyrightHolder'),
            meta: { title: '版权方管理', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/auxiliary-plot-tags',
            name: 'AuxiliaryPlotTags',
            component: () => import('@/views/auxiliary/PlotTags'),
            meta: { title: '剧情标签', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/auxiliary-plot-theme',
            name: 'AuxiliaryPlotTheme',
            component: () => import('@/views/auxiliary/PlotTheme'),
            meta: { title: '剧情题材', keepAlive: false, icon: 'PushpinOutlined' }
          },
        ]
      },
      {
        path: '/frontdesk',
        redirect: '/frontdesk-banners',
        component: RouterView,
        meta: { title: '前台设置', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/frontdesk-banners',
            name: 'FrontdeskBanners',
            component: () => import('@/views/frontdesk/Banners'),
            meta: { title: '首页首屏banner', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/frontdesk-configs',
            name: 'FrontdeskConfigs',
            component: () => import('@/views/frontdesk/Configs'),
            meta: { title: '前台配置', keepAlive: false, icon: 'PushpinOutlined' }
          },
        ]
      },
      {
        path: '/daren',
        redirect: '/daren-list',
        component: RouterView,
        meta: { title: '达人管理', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/daren-list',
            name: 'DarenList',
            component: () => import('@/views/daren/DarenList'),
            meta: { title: '达人列表', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/daren-cash-pending',
            name: 'DarenCashPending',
            component: () => import('@/views/daren/CashPending'),
            meta: { title: '待处理提现单', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/daren-cash-processed',
            name: 'DarenCashProcessed',
            component: () => import('@/views/daren/CashProcessed'),
            meta: { title: '已处理提现单', keepAlive: false, icon: 'PushpinOutlined' }
          },
        ]
      },
      {
        path: '/agency',
        redirect: '/agency-xintu-talent',
        component: RouterView,
        meta: { title: '机构分销', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/agency-xintu-talent',
            name: 'AgencyXintuTalent',
            component: () => import('@/views/agency/XintuTalent'),
            meta: { title: '星图达人库', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/agency-mgmt',
            name: 'AgencyMgmt',
            component: () => import('@/views/agency/AgencyMgmt'),
            meta: { title: '机构管理', keepAlive: false, icon: 'PushpinOutlined' }
          }
        ]
      },
      {
        path: '/settings',
        redirect: '/settings-accounts',
        component: RouterView,
        meta: { title: '系统设置', keepAlive: false, icon: 'menu_0_nomal.png', type: 2 },
        children: [
          {
            path: '/settings-accounts',
            name: 'SettingsAccounts',
            component: () => import('@/views/settings/Accounts'),
            meta: { title: '账号管理', keepAlive: false, icon: 'PushpinOutlined' }
          },
          {
            path: '/settings-permission',
            name: 'SettingsPermission',
            component: () => import('@/views/settings/Permission'),
            meta: { title: '权限管理', keepAlive: false, icon: 'PushpinOutlined' }
          },
        ]
      }
    ]
  }
]